import { reqLandmarkList } from '@/api/landmark'

export default {
  async fetchLandmarkList({ state, commit }, params) {
    try {
      commit('setIsLandmarkTableLoading', true)
      /* 處理kw params */
      let kw = null
      if (params.hasOwnProperty('kw')) {
        kw = params.kw
      } else if (state.landmarkKeyword) {
        kw = state.landmarkKeyword
      }

      const { result } = await reqLandmarkList({
        npp: 25,
        page: params.hasOwnProperty('currentPage') ? params.currentPage : 1,
        kw: kw,
      })
      commit(
        'setLandmarkList',
        result && result.landmarkInfo ? result.landmarkInfo : [],
      )
      commit(
        'setPaging',
        result && result.paging
          ? result.paging
          : {
              currentPage: 1,
              nextPage: null,
              previousPage: null,
              totalPages: 1,
              perPage: 25,
              totalEntries: 0,
            },
      )
    } catch (e) {
      throw e
    } finally {
      commit('setIsLandmarkTableLoading', false)
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/landmark/actions.js